export default "__VITE_ASSET__P7PRLXV2__"